import { aiDoes, aiDoesnt } from '../../content/methodology';

export function AiDoesAndDoesnt() {
  return (
    <section className="ai-cols-section">
      <h3>Co AI dělá a co nedělá</h3>
      <div className="ai-cols">
        <div className="ai-cols__col ai-cols__col--does">
          <h4>Dělá</h4>
          <ul>
            {aiDoes.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </div>
        <div className="ai-cols__col ai-cols__col--doesnt">
          <h4>Nedělá</h4>
          <ul>
            {aiDoesnt.map((item) => <li key={item}>{item}</li>)}
          </ul>
        </div>
      </div>
    </section>
  );
}
